module.exports = __webpack_public_path__ + "img/tr.9f829086.svg";